import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-735fb079"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "mvVideo"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  class: "mvname"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("video", {
    class: "video",
    src: $data.url,
    controls: ""
  }, null, 8, _hoisted_2), _createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: _ctx.arurl,
    alt: ""
  }, null, 8, _hoisted_4), _createElementVNode("span", _hoisted_5, _toDisplayString($props.name) + " -" + _toDisplayString($props.arname), 1)])]);
}